import { useEffect, useMemo } from 'react'
import { useSetAtom } from 'jotai'
import { customerModelAtom } from 'pages/Customers/atoms/customersAtoms'
import { CustomerModels } from 'pages/Customers/helpers/types'
import { AccountCapabilities } from 'types/capabilities/capabilities'

export const useCustomerModel = (accountCapabilities: AccountCapabilities) => {
  const setCustomerModelAtom = useSetAtom(customerModelAtom)

  const {
    isPrincipleCustomerCompanyCapabilityEnabled,
    isPrincipleCustomerIndividualCapabilityEnabled,
    isEmbeddedCustomerCompanyCapabilityEnabled,
    isEmbeddedCustomerIndividualCapabilityEnabled,
    isRelianceModelCapabilityEnabled,
  } = accountCapabilities || {}

  const isPrincipleCustomerEnabled = useMemo(
    () =>
      isPrincipleCustomerCompanyCapabilityEnabled || isPrincipleCustomerIndividualCapabilityEnabled,
    [isPrincipleCustomerCompanyCapabilityEnabled, isPrincipleCustomerIndividualCapabilityEnabled]
  )

  const isEmbeddedCustomerEnabled = useMemo(
    () =>
      isEmbeddedCustomerCompanyCapabilityEnabled || isEmbeddedCustomerIndividualCapabilityEnabled,
    [isEmbeddedCustomerCompanyCapabilityEnabled, isEmbeddedCustomerIndividualCapabilityEnabled]
  )

  const isRelianceModelEnabled = useMemo(
    () => isRelianceModelCapabilityEnabled,
    [isRelianceModelCapabilityEnabled]
  )
  const customerModel = useMemo(() => {
    if (isRelianceModelEnabled) return CustomerModels.RELIANCE
    if (isEmbeddedCustomerEnabled) return CustomerModels.EMBEDDED
    if (isPrincipleCustomerEnabled) return CustomerModels.NESTED
  }, [isEmbeddedCustomerEnabled, isPrincipleCustomerEnabled, isRelianceModelEnabled])

  const isCustomersEnabled = useMemo(() => !!customerModel, [customerModel])

  useEffect(() => {
    setCustomerModelAtom(customerModel)
  }, [customerModel])

  return { isCustomersEnabled }
}
